class ScheduleSaveView {

    constructor(onSaveFn) {
        this.saveBtn = $('.app-save-btn');
        this.saveBtn.click(onSaveFn);
        this.saveModal = $('#save');
        this.saveLink = this.saveModal.find('.app-save-link');
        this.copyToClipboard = this.saveModal.find('.copy-to-clipboard');
        this.copyToClipboard.click(this.copyLinkToClipboard.bind(this));
    }

    showSaved() {
        this.link = plannerApplication.yourProfile.getUrl() + '?restore=' + plannerApplication.yourProfile.getGuid();
        this.saveLink.attr('placeholder', this.link).val(this.link);
        this.saveModal.modal('show');
        return this.link;
    }

    copyLinkToClipboard() {
        navigator.clipboard.writeText(this.link);
    }
}
